<template>
  <div v-loading="loading" class="h-100 container">
    <!--    订单信息-->
    <part-base ref="DomForm" :key="formData.id" :form-data.sync="formData" :form-input="formInput"
               :is-operate="isOperate"
               :is-pre-executor="parseInt($route.query.isPreExecutor) === 1" :pt="parseInt($route.query.pt)"
               :show-add-btn="!!$route.query.id" @saved="saved" @goBack="goBack" @goNewAdd="goNewAdd"
               :disabledNick="disabledNick" @dealOrderData="dealOrderData" @refresh="refresh"/>

    <div v-if="userAuth.view_adv_order_agent_div" style="margin-top: 10px">
      <!--    执行部分-->
      <part-exec :key="'exec' + key" :order-id="formData.id" v-if="formData.id"/>
    </div>

    <div v-if="userAuth.view_adv_order_finance_div" style="margin-top: 10px">
      <!--    财务部分-->
      <part-finance :key="'finance' + key" :order-id="formData.id" v-if="formData.id" @reload="refresh"/>
    </div>

    <!-- 底部固定按钮 -->
    <div v-permission="'option_revoke_undo_adv_order'" class="fixed-bottom-container"
         v-if="formData.id&&parseInt(formData.bool_undo)===1">
      <div class="fixed-bottom-content">
        <el-button class="withdraw-btn" type="primary" @click="handleRevokeUndo">撤回撤单，恢复正常</el-button>
      </div>
    </div>

  </div>
</template>

<script>
import PartBase from "./components/PartBase";
import {getOrderDetailBase} from "@/api/order";
import PartExec from "@/views/adOrder/components/detail/PartExec";
import PartFinance from "@/views/adOrder/components/detail/PartFinance";
import {doOrdersRevokeUndo} from "@/api/adOrder";

export default {
  name: "Edit",
  components: {PartFinance, PartExec, PartBase},
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth
    },
  },
  data() {
    return {
      id: null,
      loading: false,
      key: new Date().getTime(),
      formData: {
        company_id: null,
        customer_name: '', //客户姓名
        customer_nature: '', //客户性质
        customer_name_custom: null,
        customer_id: '', // 客户ID
        sale: '', //销售
        sale_id: '', // 销售ID
        executor: '', // 执行
        executor_id: '', // 执行ID
        brand: '', // 选中的代理品牌
        combine_brand_id: null,
        combine_brand_name: null,
        trade: '', // 行业
        product: '', // 产品
        order_source: '', // 订单来源
        form_of_cooperation: '', // 合作形式
        exec_customer_id: null, // 执行公司id
        exec_customer_name: '', // 执行公司名称
        product_category: '', // 品类
        passenger_order_interval: '', // 客单
        remark_ffc: '',//合作形式备注：全案营销的时候显示
        project_name: null,
        strategy_name: null,
        strategy_id: null,
        planner_name: null,
        planner_id: null,
        medium_name: null,
        medium_id: null,
        //红人信息
        artist_name: null, // 红人名称
        artist_id: null, // 红人ID
        artist_ids: [], // 红人ID
        artist_nms: [], // 红人ID
        agent_name: '', // 经纪人
        release_timestamp: '', //发布时间
        created_timestamp: this.gFunc.parseTime(new Date(), '{y}-{m}-{d}'), //下单时间
        platforms: [], // 平台（多选）
        content_forms: [], // 内容形式（多选）
        ad_space_id: 0,//坑位（视频合集坑位ID）
        //费用信息
        payment_account: 0, // 含税收入
        authorized_price: 0, // 授权价
        micro_task_price: 0, // 微任务价
        micro_task_income: 0, //微任务所得
        weal_price: 0, // 粉丝福利
        invest_flow_fee: 0, // 投流费
        cart_charges: 0, //购物车费用
        cart_commission: 0, //购物车费用
        tax_point: 6, // 税点
        bool_tax: 1, // 是否含税：1(是)，0(否)
        platform_fee: 0, // 微任务平台费
        platform_fee_po: 0, // 代下单平台费
        rebates_handle: 'rebates_rate',
        rebates_amount: 0,//返点金额
        rebates_rate: 0, //返点比例
        exec_price: 0, // 执行价
        other_fee: 0,  // 其他费
        commission_rate: 0, // 佣金比例
        pay_method: '', // 支付方式
        adv_revenue: 0, // 广告收入
        is_trailer: 0,
        is_lb: 0,
        commission_trailer: null,
        commission_lb: null,
        remark: '', //备注
        //其他
        contract_filed: '',
        source_id: null,//冲账订单和复制订单
        order_type: 'regular',//订单类型：regular【普通订单】、strike【冲账订单】
        money_achievement: 0,//整单业绩金额
        offline_rebate: 0,//线下结佣
        place_order_money: null,// 下单金额 当平台包含”抖音星图“时显示
        puke_id: null,
        real_income: null,
        // 关联询单
        iq_id: null,
        iq_nm: '',
      },
      formInput: true,
      isOperate: 0,//
      disabledNick: false
    }
  },
  watch: {
    "formData.covenant_id"(_) {
      if (!_) {
        this.formData.covenant_id = null
      }
    }
  },
  methods: {
    goBack() {
      this.$router.push({name: "ad-order"});
      // this.$router.back()
    },
    goNewAdd() {
      const {href} = this.$router.resolve({
        name: `detailAdOrder`,
        query: {type: "add"}
      });
      window.open(href, "_self");
    },
    // 处理订单数据  不同操作数据组装
    dealOrderData() {
    },
    //修改订单后
    saved() {
      this.showToast({
        h: this,
      })
      this.key = new Date().getTime()
    },
    async getOrderDetail() {
      this.loading = true
      //获取订单信息 getOrderDetailBase
      let {info} = await getOrderDetailBase({id: this.id}).then((res) => {
        return res.model;
      })
      if (info.artist_id && info.is_mark) {
        this.disabledNick = true
      }
      if (info.form_of_cooperation === '纯直播') {
        const query = {...this.$route.query, ...{isPureLive: true}}
        await this.$router.push({query})
      }
      this.loading = false
      this.formData = info
      this.$nextTick(() => {
        this.$refs.DomForm.setData()
      })
    },
    async refresh() {
      await this.getOrderDetail()
      this.key = new Date().getTime()
    },
    handleRevokeUndo: function () {
      const row = this.formData;
      let msg = `订单编号：${row.order_no} 客户：${row.customer_name} 建单人：${row.creator || row.creator_name} `

      let that = this;
      this.showModal({
        h: this,
        text: msg + "，确定撤回撤单吗？",
        confirmText: "",
        cancelText: "",
        confirm: async function () {
          that.loading = true
          const response = await doOrdersRevokeUndo({id: row.id});
          that.loading = false
          if (!response.success) {
            that.$notify.warning({title: '提示', message: response.message});
            return false
          }
          that.showToast({
            h: that,
            icon: "el-icon-success",
            text: "操作成功",
            duration: 2000
          });
          setTimeout(() => {
            that.refresh()
          }, 2000)
        }
      });
    }
  },
  created() {
    this.id = this.$route.params && this.$route.params.id;
    this.getOrderDetail()
  }
}
</script>

<style scoped>
.card-title {
  position: relative;
  /*padding-top: 24px;*/
  padding-left: 55px;
  margin-bottom: 15px;
  color: rgba(50, 50, 50, 1);
  line-height: 24px;
  font-size: 14px;
  font-weight: bold;
  text-align: left;
}

.card-title::after {
  content: "";
  position: absolute;
  bottom: 6.5px;
  left: calc(55px - 8px - 6px);
  width: 8px;
  height: 8px;
  background: rgba(224, 63, 61, 1);
  border-radius: 2px;

}

.formCard {
  padding: 24px 20px;
  border-radius: 6px;
  border: 1px solid rgba(221, 221, 221, 1);
  /*margin-bottom: 16px;*/
  width: 95%;
  margin: 5px auto;
}

/* 底部固定容器 */
.fixed-bottom-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-top: 1px solid rgba(221, 221, 221, 0.5);
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  padding: 16px 0;
}

/* 底部固定内容 */
.fixed-bottom-content {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 撤回撤单按钮 */
.withdraw-btn {
  background-color: #ff0000 !important;
  border-color: #ff0000 !important;
  color: #ffffff !important;
  font-weight: 500;
  font-size: 14px;
  padding: 12px 32px;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(255, 0, 0, 0.3);
  transition: all 0.3s ease;
  min-width: 120px;
}

.withdraw-btn:hover {
  background-color: #e60000 !important;
  border-color: #e60000 !important;
  box-shadow: 0 6px 16px rgba(255, 0, 0, 0.4);
  transform: translateY(-1px);
}

.withdraw-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(255, 0, 0, 0.3);
}

</style>
